import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  PaginatorLayoutInfo,
  PaginatorLayoutRenderer,
} from './paginator-layout-renderer';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent implements AfterViewInit, OnChanges, OnDestroy {
  private subscriptions: Subscription[] = [];
  private paginatorLayoutRenderer!: PaginatorLayoutRenderer;

  visibleCount = 0;

  layoutInfo!: PaginatorLayoutInfo;

  @Input()
  currentPageIndex = 0;

  @Input()
  pageCount = 0;

  @Output()
  pageChange = new EventEmitter<number>();

  @ViewChild('dynamicLinksContainer')
  dynamicLinksContainer!: ElementRef<HTMLElement>;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.paginatorLayoutRenderer = new PaginatorLayoutRenderer(
      this.dynamicLinksContainer.nativeElement
    );
    this.paginatorLayoutRenderer.setPageCount(this.pageCount);
    this.paginatorLayoutRenderer.start();

    const layoutInfoSubscription =
      this.paginatorLayoutRenderer.layoutInformation.subscribe((info) => {
        this.layoutInfo = info;
        this.cdRef.markForCheck();
      });
    this.subscriptions.push(layoutInfoSubscription);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.paginatorLayoutRenderer?.setPageCount(this.pageCount);
    this.paginatorLayoutRenderer?.setCurrentPageIndex(this.currentPageIndex);
  }

  ngOnDestroy() {
    this.paginatorLayoutRenderer.destroy();
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  previousPage() {
    this.goToPage(this.currentPageIndex - 1);
  }

  nextPage() {
    this.goToPage(this.currentPageIndex + 1);
  }

  goToPage(pageNumber: number) {
    this.pageChange.emit(pageNumber);
  }

  trackBy(index: number, value: number) {
    return value;
  }

  get maxIndex(): number {
    return this.pageCount - 1;
  }

  get isPreviousButtonDisabled(): boolean {
    return this.currentPageIndex <= 0;
  }

  get isNextButtonDisabled(): boolean {
    return this.currentPageIndex >= this.maxIndex;
  }
}
